const fans = {
    state: {
        refreshStatus: null
    },
    getters: {
        getRobotFansRefreshStatusById: (state) => {
            return (id) => {
                const key = `${id}`
                if (state.refreshStatus && state.refreshStatus[key]) {
                    return state.refreshStatus[key]
                } else {
                    return false
                }
            }
        }
    },
    mutations: {
        SET_REFRESHSTATUS(state, refreshStatus) {
            state.refreshStatus = refreshStatus
        }
    },

    actions: {
        updateFansRefreshStatus({ commit, state }, { sub_id, data }) {
            let refreshStatus = state.refreshStatus || {}
            const atpresent = data.atpresent
            const key = `${sub_id}`
            refreshStatus[key] = {
                conduct: true,
                progress: atpresent
            }
            commit('SET_REFRESHSTATUS', refreshStatus)
            if (atpresent === 100) {
                setTimeout(() => {
                    refreshStatus[key] = {
                        conduct: false,
                        progress: atpresent
                    }
                }, 1000);
            }
        }
    }
}

export default fans
